import { i18n } from '@lingui/core';
export { formats, i18n, setupI18n } from '@lingui/core';
import { detect, fromUrl, fromHtmlTag, fromStorage, fromNavigator } from '@lingui/detect-locale';
import { m as messages } from './messages-8dbfe16f.browser.esm.js';
import { en } from 'make-plural/plurals';

i18n.loadLocaleData('en', {
  plurals: en
});
i18n.load('en', messages);
i18n.activate('en');
/**
 * Detect the locale that is being
 */

function detectLocale() {
  var _detect;

  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lang';
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  return (_detect = detect(fromUrl(key), fromHtmlTag('html'), fromStorage(key), fromNavigator())) !== null && _detect !== void 0 ? _detect : fallback;
}

export { detectLocale };
